import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getPerformance } from "firebase/performance";
import devConfig from "../../firebase-config/dev.json";
import stageConfig from "../../firebase-config/stage.json";
import prodConfig from "../../firebase-config/prod.json";

export const init = () => {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "test") {
    return;
  }

  const isBrowser =
    typeof window !== "undefined" && typeof window.document !== "undefined";
  const isFirebaseEnv =
    process.env.NEXT_PUBLIC_FIREBASE_ENV === "dev" ||
    process.env.NEXT_PUBLIC_FIREBASE_ENV === "stage" ||
    process.env.NEXT_PUBLIC_FIREBASE_ENV === "prod";

  if (isFirebaseEnv) {
    const app = initializeApp(firebaseConfigForFirebaseEnv());
    getAuth(app);

    if (isBrowser) {
      getPerformance(app);
    }
    return;
  }

  const app = initializeApp(devConfig);
  const db = getFirestore(app);

  if (process.env.NODE_ENV === "development") {
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
  }
};

const firebaseConfigForFirebaseEnv = () => {
  if (process.env.NEXT_PUBLIC_FIREBASE_ENV === "stage") {
    return stageConfig;
  } else if (process.env.NEXT_PUBLIC_FIREBASE_ENV === "prod") {
    return prodConfig;
  }
  return devConfig;
};
